// extracted by mini-css-extract-plugin
export default {"wrapper":"SantaShowcaseSwitcher_wrapper","isCertificate":"SantaShowcaseSwitcher_isCertificate","icon":"SantaShowcaseSwitcher_icon","cn360":"SantaShowcaseSwitcher_cn360"};